import NoAccessLockIcon from "../icons/NoAccessLockIcon";
import DataLoadingFailed from "./DataLoadingFailed";

interface Props {
  text: string;
}

const NoAccessPlaceholder = ({ text }: Props) => (
  <DataLoadingFailed Icon={NoAccessLockIcon} title="No access" text={text} />
);

export default NoAccessPlaceholder;
